import React, { Component } from 'react';
import { Modal, ModalBody, ModalHeader, ModalFooter, Button } from 'reactstrap';
import { withTranslation } from 'react-i18next';

class DataExplorerJsonModal extends Component {
  state = { copied: false };

  handleCopyToClipboard = () => {
    navigator.clipboard.writeText(this.props.jsonContent);
    this.setState({ copied: true });
    setTimeout(() => this.setState({ copied: false }), 2000);
  };

  handleDownload = () => {
    const blob = new Blob([this.props.jsonContent], { type: 'application/json' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'data-node-request.json';
    a.click();
    URL.revokeObjectURL(url);
  };

  render() {
    const { isOpen, toggle, jsonContent, t } = this.props;
    return (
      <Modal isOpen={isOpen} toggle={toggle} size="lg">
        <ModalHeader toggle={toggle}>
          {t('data_explorer.json_for_data_node_title')}
        </ModalHeader>
        <ModalBody>
          <textarea
            readOnly
            value={jsonContent}
            style={{
              width: '100%',
              height: '400px',
              fontFamily: 'monospace',
              fontSize: '12px',
              padding: '10px',
              border: '1px solid #ddd',
              borderRadius: '4px',
              backgroundColor: '#f8f9fa',
              resize: 'none'
            }}
          />
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={this.handleCopyToClipboard}>
            {this.state.copied
              ? t('data_explorer.copied_to_clipboard')
              : t('data_explorer.copy_to_clipboard')}
          </Button>
          <Button color="primary" onClick={this.handleDownload}>
            {t('data_explorer.download_json')}
          </Button>
        </ModalFooter>
      </Modal>
    );
  }
}

export default withTranslation()(DataExplorerJsonModal);
